<template>
  <div :id="data.id" class="bg-gray-lighten3 py-20 text-slate md:py-28">
    <div class="container flex flex-col gap-y-20 lg:gap-y-28">
      <div
        v-for="(block, i) in (data && data.items) || []"
        :key="i"
        class="lg:grid lg:grid-cols-2 lg:items-center lg:justify-between lg:gap-x-4"
      >
        <div
          class="relative mb-8 overflow-hidden rounded-lg pt-[75%] lg:mb-0"
          :class="{ 'md:order-last': i % 2 === 0 }"
        >
          <UiVideo
            v-if="block.video"
            :src="getAssetUrl(block.video)"
            class="absolute inset-0"
            container-size
            play
            autoplay
          ></UiVideo>

          <div
            v-else-if="block.image"
            v-lazy-background="getAssetUrl(block.image)"
            class="absolute inset-0 bg-cover bg-center bg-no-repeat"
          ></div>
        </div>

        <div class="flex flex-col items-center justify-center">
          <div class="w-full xl:w-[440px] 3xl:w-[600px]">
            <UiSectionTitle
              v-if="block.title"
              :title="block.title"
              tag="h3"
              class="title text-xl uppercase leading-none md:text-3xl xl:whitespace-pre-line xl:text-5xl"
            />

            <p
              v-if="block.text"
              class="text-md leading-[1.8rem] xl:whitespace-pre-line"
              :class="block.list ? 'mt-4' : 'mt-4 xl:mt-6'"
              v-html="block.text"
            />

            <ul
              v-if="block.list"
              class="mt-6 flex flex-col gap-y-2 text-sm leading-[1.225rem] md:text-lg xl:mt-8"
            >
              <li
                v-for="(listItem, l) in block.list"
                :key="l"
                class="relative border-l-2 border-[#00A7E1] pl-[18px]"
                v-html="listItem"
              />
            </ul>

            <div v-if="block.icons" class="mt-6 overflow-x-auto xl:mt-8">
              <ul class="flex gap-x-2">
                <li
                  v-for="(icon, ii) in block.icons"
                  :key="ii"
                  v-lazy-background="getAssetUrl(icon)"
                  class="h-10 w-10 flex-shrink-0 rounded-lg bg-white bg-contain bg-center bg-no-repeat"
                ></li>
              </ul>
            </div>

            <div v-if="block.button && block.button.link" class="mt-6 xl:mt-8">
              <UiButton
                size="md"
                :to="block.button.link"
                :target="block.button.target"
              >
                <span v-html="block.button.text" />
              </UiButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMediaAsset } from '~/composables';

interface Props {
  data?: { id?: string; items: any };
}

withDefaults(defineProps<Props>(), {
  data: () => ({ items: [] }),
});

const { getAssetUrl } = useMediaAsset();
</script>
